/**
 * 简单 Toast（替代 uni.showToast）
 */
let toastEl = null
let timer = null

function ensureToast() {
  if (toastEl) return toastEl
  toastEl = document.createElement('div')
  toastEl.className = 'app-toast'
  document.body.appendChild(toastEl)
  return toastEl
}

export function showToast(options = {}) {
  const { title = '', duration = 2000 } = typeof options === 'string' ? { title: options } : options
  const el = ensureToast()
  el.textContent = title
  el.className = 'app-toast app-toast-show'
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => {
    el.classList.remove('app-toast-show')
    timer = null
  }, duration)
}

export function hideToast() {
  if (toastEl) toastEl.classList.remove('app-toast-show')
  if (timer) clearTimeout(timer)
  timer = null
}
